import * as React from "react";
import { CustomFilterRenderProps } from "Components/ScrollableTable/components/ScrollableTableHeader";
import { DatePicker, Row, Button, Input, Divider } from "antd";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { dayjs } from "Config/dayjs";

interface ViewDateFilterProps extends CustomFilterRenderProps {
  showYoungerThanDays?: boolean;
  onYoungerThanDaysChange?: (days: string) => void;
  youngerThanDaysValue?: string;
}

export const ViewDateFilter = (props: ViewDateFilterProps) => {
  const { t } = useTranslation([I18N_NS.GENERAL, I18N_NS.PROJECT]);
  const [dateRange, setDateRange] = React.useState([]);
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [days, setDays] = React.useState(props.youngerThanDaysValue);

  const handleChange = (val: dayjs.Dayjs, idx: number) => {
    const newDateRange = dateRange.slice();
    if (idx === 1) {
      setTo(val);
      val = val?.endOf("day");
    } else if (idx === 0) {
      setFrom(val);
      val = val?.startOf("day");
    }
    newDateRange[idx] = val;
    setDateRange(newDateRange);
    props.setFilters(newDateRange);
  };

  const handleSetDays = (e) => {
    const value = e.target.value;
    const num = Number(value);
    if (!num) {
      setDays("");
      return;
    }
    if (num > 999) {
      return;
    }
    setDays(num.toString());
  };

  const handleCancel = () => {
    setFrom(null);
    setTo(null);
    setDays("");
    if (props.showYoungerThanDays) {
      props.onYoungerThanDaysChange("");
    }
    props.clearFilters();
  };

  const confirm = () => {
    if (props.showYoungerThanDays) {
      props.onYoungerThanDaysChange(days);
    }
    props.confirm();
  };

  React.useEffect(() => {
    if (days !== props.youngerThanDaysValue) {
      setDays(props.youngerThanDaysValue);
    }
  }, [props.youngerThanDaysValue]);

  return (
    <div>
      <div className="mb-sm">
        <DatePicker
          style={{ width: "100%" }}
          format="DD.MM.YYYY"
          value={from}
          onChange={(val) => handleChange(val, 0)}
          placeholder={t("From")}
        />
      </div>
      <div className="mb-sm">
        <DatePicker
          style={{ width: "100%" }}
          format="DD.MM.YYYY"
          value={to}
          onChange={(val) => handleChange(val, 1)}
          placeholder={t("To")}
        />
      </div>
      {props.showYoungerThanDays && (
        <>
          <Divider style={{ margin: "10px 0" }} />
          <div className="mb-sm">
            <Input
              value={days}
              onChange={handleSetDays}
              placeholder={t("Younger than", { ns: I18N_NS.PROJECT })}
              onPressEnter={confirm}
            />
          </div>
        </>
      )}
      <Row justify="space-between">
        <Button size="small" onClick={handleCancel}>
          {t("Reset")}
        </Button>
        <Button size="small" type="primary" onClick={confirm}>
          OK
        </Button>
      </Row>
    </div>
  );
};
